export function SkeletonCard({ height = 64 }: { height?: number }) {
  return (
    <div className="skeleton" style={{ height, margin: '8px 16px', borderRadius: 12 }} />
  )
}

export function SkeletonList({ count = 4 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </>
  )
}
